const language = document.getElementById('lang').innerHTML;
const country = document.getElementById('country').innerHTML;

function text(translationsMap) {
  let result = translationsMap[language];
  if (result == undefined) {
    return translationsMap['en'];
  } else {
    return translationsMap[language];
  }
}

function subdomain() {
  return {"spain": "es"}[country];
}

function taxForm() {
  return (country == 'russia'
    ? <>
      <a href="https://finparser.com/tax-form/"
        target='_blank'>FinParser</a>
    </>
    : <>
      <a href={text({
        "ru": `https://${subdomain()}.robotaxmaker.com/ru/tax-form/`,
        "ua": `https://${subdomain()}.robotaxmaker.com/uk/tax-form/`,
        "en": `https://${subdomain()}.robotaxmaker.com/en/tax-form/`,
        "es": `https://${subdomain()}.robotaxmaker.com/tax-form/`
      })}
        target='_blank'>RoboTaxMaker</a>
    </>);
}

function brokerReport(year) {
  return text({
    "ru": <div>
      Отчет за<br />
      {year} год<br />
      (Excel)
    </div>,
    "ua": <div>
      Звіт за<br />
      {year} рік<br />
      (Excel)
    </div>,
    "en": <div>
      Report for<br />
      {year}<br />
      (Excel)
    </div>,
    "es": <div>
      Informe para<br />
      el año {year}<br />
      (Excel)
    </div>
  });
}

function taxReturn(year) {
  return text({
    "ru": <div>
      Налоговая<br />
      декларация<br />
      за {year} год
    </div>,
    "ua": <div>
      Податкова<br />
      декларація<br />
      за {year} рік
    </div>,
    "en": <div>
      Tax<br />
      return<br />
      for {year}
    </div>,
    "es": <div>
      Declaración<br />
      de impuestos<br />
      para el año {year}
    </div>
  });
}

function universalFormat(year) {
  return text({
    "ru": <div>
      Сделки и позиции в формате<br />
      {country == 'russia' ? "FinParser" : "RoboTaxMaker"} по состоянию<br />
      на конец {year} года (Excel)
    </div>,
    "ua": <div>
      Угоди та позиції у форматі<br />
      {country == 'russia' ? "FinParser" : "RoboTaxMaker"} станом на<br />
      кінець {year} року (Excel)
    </div>,
    "en": <div>
      Transactions and positions in<br />
      {country == 'russia' ? "FinParser" : "RoboTaxMaker"} format as of<br />
      the end of {year} (Excel)
    </div>,
    "es": <div>
      Transacciones y posiciones<br />
      en formato {country == 'russia' ? "FinParser" : "RoboTaxMaker"}<br />
      a finales de {year} (Excel)
    </div>
  });
}

function taxAgency() {
  return (country == 'russia'
    ? <>
      <a href="https://www.nalog.gov.ru"
        target='_blank'>nalog.ru</a>
    </>
    : <>
      <a href={text({
        "ru": "https://sede.agenciatributaria.gob.es/Sede/en_gb/irpf/gestiones-irpf.html",
        "ua": "https://sede.agenciatributaria.gob.es/Sede/en_gb/irpf/gestiones-irpf.html",
        "en": "https://sede.agenciatributaria.gob.es/Sede/en_gb/irpf/gestiones-irpf.html",
        "es": "https://sede.agenciatributaria.gob.es/Sede/irpf/gestiones-irpf.html"
      })}
        target='_blank'>Agencia Tributaria Renta</a>
    </>);
}

export default [
  {
    id: 'abylaiGS',
    data: {
      label: (
        country == 'russia'
          ? <>
            <a href="https://finparser.com/docs/abylaigs_report"
              target='_blank'>Abylai GS</a>
          </>
        : <>
            <a href={text({
              "ru": `https://${subdomain()}.robotaxmaker.com/ru/docs/abylaigs_report`,
              "ua": `https://${subdomain()}.robotaxmaker.com/uk/docs/abylaigs_report`,
              "en": `https://${subdomain()}.robotaxmaker.com/en/docs/abylaigs_report`,
              "es": `https://${subdomain()}.robotaxmaker.com/docs/abylaigs_report`
            })}
               target='_blank'>Abylai GS</a>
          </>
      ),
    },
    position: { x: 250, y: 0 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      border: '1px solid #0066CC',
    },
  },
  {
    id: 'robotaxmaker',
    data: {
      label: <>{taxForm()}</>,
    },
    position: { x: 250, y: 150 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      border: '1px solid #0066CC',
    },
  },
  {
    id: 'taxAgency',
    data: {
      label: <>{taxAgency()}</>,
    },
    position: { x: 500, y: 225 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      border: '1px solid #000000',
    },
  },
  {
    id: 'robotaxmaker2',
    data: {
      label: <>{taxForm()}</>,
    },
    position: { x: 250, y: 300 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      border: '1px solid #0066CC',
    },
  },
  {
    id: 'infinity__...',
    data: { label: '' },
    position: { x: 324, y: 450 },
    type: 'emptyNode',
  },
  // edges
  {
    id: 'abylaiGS-b3->robotaxmaker',
    source: 'abylaiGS',
    target: 'robotaxmaker',
    data: {
      label: <>{brokerReport(2025)}</>,
      height: 44,
      width: 80
    },
    type: 'labelEdge',
    style: { stroke: '#000000' },
    animated: true,
  },
  {
    id: 'robotaxmaker->taxAgency',
    source: 'robotaxmaker',
    sourceHandle: 'r',
    target: 'taxAgency',
    targetHandle: 'l',
    data: { label: <>{taxReturn(2025)}</>,
            height: 44,
            width: 120},
    type: 'labelEdge',
    style: { stroke: '#000000' },
    animated: true,
  },
  {
    id: 'robotaxmaker->robotaxmaker2',
    source: 'robotaxmaker',
    sourceHandle: 'bottom',
    target: 'robotaxmaker2',
    targetHandle: 'top',
    data: { label: <>{universalFormat(2025)}</>,
            height: 44,
            width: 140},
    type: 'labelEdge',
    style: { stroke: '#000000' },
    animated: true,
  },
  {
    id: 'robotaxmaker2->taxAgency',
    source: 'robotaxmaker2',
    sourceHandle: 'r',
    target: 'taxAgency',
    targetHandle: 'l',
    data: { label: <>{taxReturn(2026)}</>,
            height: 44,
            width: 120},
    type: 'labelEdge',
    style: { stroke: '#000000' },
    animated: true,
  },
  {
    id: 'robotaxmaker2->infinity__...',
    source: 'robotaxmaker2',
    sourceHandle: 'bottom',
    target: 'infinity__...',
    data: { label: <>{universalFormat(2026)}</>,
            height: 44,
            width: 140},
    type: 'labelEdge',
    style: { stroke: '#000000' },
    animated: true,
  },
  // ib - ib-a - Отчет за 2021 год (CSV) - ib-b -> FinParser
  {
    id: 'abylaiGS-a',
    data: { label: '' },
    type: 'emptyNode',
    position: { x:200, y: 103 },
  },
  {
    id: 'abylaiGS-b',
    data: { label: '' },
    position: { x: 200, y: 225 },
    type: 'emptyNode',
  },
  {
    id: 'abylaiGS->abylaiGS-a',
    source: 'abylaiGS',
    target: 'abylaiGS-a',
    sourceHandle: 'l',
    style: { stroke: '#000000' },
    animated: true,
  },
  {
    id: 'abylaiGS-a->abylaiGS-b',
    source: 'abylaiGS-a',
    target: 'abylaiGS-b',
    label: 'Отчет за 2021 год (Excel)',
    data: {
      label: <>{brokerReport(2026)}</>,
      height: 44,
      width: 80
    },
    type: 'labelEdge',
    style: { stroke: '#000000' },
    animated: true,
  },
  {
    id: 'abylaiGS-b-robotaxmaker2',
    source: 'abylaiGS-b',
    target: 'robotaxmaker2',
    targetHandle: 'l',
    style: { stroke: '#000000' },
    animated: true,
  },
];
